export const defaultOperation = {
  polling: {
    perform: {
      headers: {
        Accept: 'application/json',
      },
    },
  },
  hook: {
    perform: {
      source: 'return [bundle.cleanedRequest];',
    },
    performList: {
      headers: {
        Accept: 'application/json',
      },
    },
    performSubscribe: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: {
        hookUrl: '{{bundle.targetUrl}}',
      },
    },
    performUnsubscribe: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: {
        hookUrl: '{{bundle.subscribeData.id}}',
      },
    },
  },
};
